import MomentDate from 'Components/MomentDate';

export default function MessageDate({
  value,
  className,
}: {
  value: string;
  className?: string;
}) {
  return (
    <div className={className}>
      <MomentDate date={value} format={'MMMM Do YYYY [at] h:mm A'} />
    </div>
  );
}
